import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import ClipLoader from 'react-spinners/ClipLoader';
import moment from 'moment';

import { CcusListUsers } from '../components/CcusListUsers';
import { CcusListAddition } from '../components/CcusListAddition';
import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import { MasterPageHeader } from '../components/PageHeader';

import { CompanyService } from '../services/Companies';
import { PrimeCCUSPreviewService } from '../services/PrimeCCUSPreview'; // ユーザー情報API
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import { DATE_TIME_FORMAT, HEADER_CONSTANTS } from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  isPartnerRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import { requestCache } from '../utilities/requestCache';
import {
  getPartnerCompanyName,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';

import PrintUtility from '../utilities/printUtility';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { DownloadFileErrorDialog } from '../components/modals/DownloadFileErrorDialog';
import { messageUtility } from '../utilities/messageUtility';
import dialogLoader from '../utilities/dialogLoader';
import {
  PrimeDeleteCCUSConfirmation,
  DeleteCCUSConfirmation,
  DeleteCCUSFailureInfo,
  CCUSNoDelegateNameDialog,
} from '../components/CcusBase';

import { getCompanyId } from '../utilities/commonUtil';

export const CCUS_STATUS = {
  OK: 1,
  NG: 2,
  DEFAULT: 0,
};

export const CCUS_PAGE = {
  CcusCompanyCreate: 'CcusCompanyCreate',
  CcusCompanyEdit: 'CcusCompanyEdit',
  CcusAdminCreate: 'CcusAdminCreate',
  CcusAdminEdit: 'CcusAdminEdit',
  CcusCompanyUserEdit: 'CcusCompanyUserEdit',
  CcusAdminUserEdit: 'CcusAdminUserEdit',
};

/**
 * @description 会社情報編集_CCUS連携情報画面
 */
export class PrimeCcusPreview extends React.Component {
  constructor(props) {
    super(props);

    this.selectedCompanyId = propsToCompanyId(this.props);
    this.isOwnCompany =
      Number(
        SessionStorageService.getItem('sessionPartnerCompanyIdOfPrimeCompany')
      ) === this.selectedCompanyId;
    //FIX ME：this.isOwnCompanyが元請の場合の比較に対応しておらず設置したが、
    // src/pages/CcusCompany.jsxを見るに↓で協力会社の場合も比較できるので、
    // 可能な時に纏めて欲しい
    this.primeOwnerCompanyId = getCompanyId();
    this.isPrimeOwnerCompny =
      Number(this.primeOwnerCompanyId) === Number(this.selectedCompanyId);
    sessionStorage.setItem('companyCcusId', this.selectedCompanyId);
    this.isRolePartner = isPartnerRoleId(LocalStorageService.getRoleId());
    this.isPrimaryCompanyRole = isPrimaryCompanyRoleId(
      LocalStorageService.getRoleId()
    );

    this.state = {
      selectedCompanyName: '',
      dataBasicInfo: {
        ccus_company_admin_id: null,
        ccus_company_admin_name: null,
        company_id: null,
        connection_status: 0,
        connection_label: '未確認',
        id: null,
        ccus_jigyousya_id: null,
      },
      dataUserInfo: [],
      dataAdditionInfo: [],
      isLoading: false,
      visibleDownloadErrorDialog: false,
      visibleCcusDeleteDialog: false,
      visibleCcusNoDelegateNameDialog: false,
      expirationCompany: {},
      isShowBtnDeleteCCUS: false,
    };

    this.events = {
      goBack: this.goBack,
    };
    this.isSubmittingFlag = false;
    this.isDownloadingFlag = false;
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  goBack = () => {
    _masterSlideLoader.show('AgencyCompanies', {
      state: {},
    });
  };

  componentDidMount() {
    this.setCompanyName();
    this.getBasicInfo();
    this.getExpiration();
    this.getAgencyInfo();
  }

  componentWillUnmount() {
    requestCache.clear(); //割り当てでキャッシュしたレスポンスを解放
  }

  setCompanyName = async () => {
    this.setState({ isLoading: true });

    let companyName = '';

    try {
      if (this.isRolePartner) {
        companyName = await getPartnerCompanyName(this.selectedCompanyId);
        this.setState({ selectedCompanyName: companyName });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getBasicInfo = async () => {
    const response = await PrimeCCUSPreviewService.getBasicInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      const entities = response.data.entities;
      const destroyableFlag = _.get(
        entities,
        'ccus_company_admin.destroyable_flag'
      );
      let connection_label;
      switch (String(_.get(entities, 'ccus_company_admin.connection_status'))) {
        case '1':
          const strDate = moment(
            _.get(entities, 'ccus_company_admin.last_connected_at')
          ).format(DATE_TIME_FORMAT.slashDateFormat);
          connection_label = `OK (${strDate})`;
          break;
        case '2':
          connection_label = 'NG';
          break;
        default:
          connection_label = '未確認';
      }
      this.setState(
        {
          dataBasicInfo: {
            ...entities.ccus_company_admin,
            ccus_jigyousya_id: entities.ccus_jigyousya_id,
            connection_label,
            has_delegate_name: entities.has_delegate_name,
          },
          isShowBtnDeleteCCUS: destroyableFlag,
        },
        () => {
          this.getListAdditions();
          const ccus_company_admin_id = _.get(
            entities,
            'ccus_company_admin.id'
          );
          if (ccus_company_admin_id) {
            this.getListUsers(ccus_company_admin_id);
          }
        }
      );
    }
  };

  getListUsers = async id => {
    const response = await PrimeCCUSPreviewService.getListUsersInfo(
      this.selectedCompanyId,
      { ccus_company_admin_id: id }
    );
    if (response.result) {
      this.setState({
        dataUserInfo: response.data.entities.ccus_company_admins,
      });
    }
  };

  getListAdditions = async () => {
    const response = await PrimeCCUSPreviewService.getListAdditionInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      this.setState({
        dataAdditionInfo: response.data.entities.ccus_company_admins,
      });
    }
  };

  moveCcusUserPage = (page, item = {}) => {
    _masterSlideLoader.show(page, {
      state: {
        id: item.id,
      },
    });
  };

  moveCcusAdminForm = (page, item) => {
    if (page === CCUS_PAGE.CcusAdminEdit) {
      const { id } = item;
      _masterSlideLoader.show(page, {
        state: { id },
      });
    } else {
      _masterSlideLoader.show(page, {
        state: { id: this.selectedCompanyId },
      });
    }
  };

  moveCcusCompanyForm = page => {
    _masterSlideLoader.show(page, {
      state: { id: this.selectedCompanyId },
    });
  };

  downloadFileManual = async (fileCode, fileName) => {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    await PrintUtility.downloadStaticFilePDF(
      fileCode,
      fileName,
      this.setVisibleDownloadErrorDialog
    );
    this.isDownloadingFlag = false;
  };

  setVisibleDownloadErrorDialog = value => {
    this.setState({ visibleDownloadErrorDialog: value });
  };

  // BLDE_V2-42611 CCUS事業者IDの削除ボタンのアクション
  handleDeleteCCUS = () => {
    // 元請ユーザーの場合
    if (this.isPrimaryCompanyRole) {
      this.setState({ visibleCcusDeleteDialog: true });
    }
    // 協力会社管理者ユーザーの場合
    if (this.isRolePartner) {
      // BLDE_V2-42611 代表者名が未登録の場合、代表者名を登録するように促すダイアログを表示する
      if (this.state.dataBasicInfo.has_delegate_name) {
        this.setState({ visibleCcusDeleteDialog: true });
      } else {
        this.setState({ visibleCcusNoDelegateNameDialog: true });
      }
    }
  };

  /**
   * call API delete CCUS cooperation information
   * show failure dialog within having error
   * reload page when done
   */
  onDeleteCCUS = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const response = await PrimeCCUSPreviewService.deleteBasicInfo(
      this.selectedCompanyId
    );
    this.isSubmittingFlag = false;
    dialogLoader.close();
    if (response.result) {
      window.location.reload();
    } else {
      dialogLoader.show(DeleteCCUSFailureInfo, {
        callback: {
          done: () => {
            window.location.reload();
          },
        },
      });
    }
  };

  getAgencyInfo = async () => {
    const response = await PrimeCCUSPreviewService.getAgencyInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      this.setState({
        agencyInfo: response.data.entities.agency_info,
      });
    }
  };

  renderCCUSDeleteConfirmation = () => {
    if (this.isPrimaryCompanyRole) {
      // 元請ユーザーの場合、「CCUS連携情報の削除確認」ダイアログを表示する
      return (
        <PrimeDeleteCCUSConfirmation
          visible={this.state.visibleCcusDeleteDialog}
          onCancel={() => this.setState({ visibleCcusDeleteDialog: false })}
          onConfirm={this.onDeleteCCUS}
        />
      );
    } else {
      // BLDE_V2-42611 協力会社ユーザーの場合、「CCUS事業者IDの削除」警告ダイアログを表示する
      return (
        <DeleteCCUSConfirmation
          dataBasicInfo={this.state.dataBasicInfo}
          selectedCompanyName={this.state.selectedCompanyName}
          visible={this.state.visibleCcusDeleteDialog}
          onCancel={() => this.setState({ visibleCcusDeleteDialog: false })}
          onConfirm={this.onDeleteCCUS}
        />
      );
    }
  };

  render() {
    const {
      isLoading,
      dataBasicInfo,
      dataUserInfo,
      dataAdditionInfo,
      selectedCompanyName,
      visibleDownloadErrorDialog,
      visibleCcusDeleteDialog,
      visibleCcusNoDelegateNameDialog,
      isShowBtnDeleteCCUS,
    } = this.state;

    const { ccus_jigyousya_id, ccus_company_admin_id } = dataBasicInfo;

    const title = `${selectedCompanyName}会社情報`;
    const labelBtnCcusCompany = ccus_jigyousya_id
      ? '基本情報を編集'
      : '基本情報を登録';

    return (
      <div
        id='slide-view'
        className='contruction-slide-view show PrimeCcusPreview'
      >
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            loaded={!isLoading}
            loaderComponent={
              <div className='contruction-slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            title={title}
            onClose={() => _masterSlideLoader.close(this.props.vw)}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className={'contruction-detail-view'}>
              <div className={'contruction-detail-view__sidemenu'}>
                {this.isPrimaryCompanyRole && (
                  <PrimaryCompanyNaviList
                    isSelectedCcusManagementInfo={true}
                    expirationCompany={this.state.expirationCompany}
                  />
                )}
                {this.isRolePartner && (
                  <PartnerNaviList
                    isCcusManagementInfo={true}
                    selectedPartnerCompanyId={this.selectedCompanyId}
                    expirationCompany={this.state.expirationCompany}
                  />
                )}
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {!this.isOwnCompany && this.isRolePartner && (
                  <div style={{ padding: '10px 20px 0' }}>
                    <button
                      className='btn-text--sm'
                      onClick={() => {
                        this.events.goBack();
                      }}
                    >
                      <i className='i-back--blue i-2x vertical-middle' />
                      代行先一覧
                    </button>
                  </div>
                )}
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
                  <FormList>
                    <FormListSubHeader
                      title='CCUS（建設キャリアアップシステム）と連携するには'
                      noMarginTop={true}
                    />
                    <div className='description'>
                      {this.isPrimeOwnerCompny || this.isOwnCompany
                        ? '連携にはCCUSの「事業者ID」「管理者ID」「パスワード（またはセキュリティコード）」が必要です。'
                        : '連携にはCCUSの「事業者ID」「管理者ID」「セキュリティコード」が必要です。'}
                      <br />
                      お手元にCCUSの「事業者情報登録完了のお知らせ」をご用意いただくと、設定がスムーズに進みます。
                      <br />
                      「事業者情報登録完了のお知らせ」はメールもしくは、書面にて通知されます。
                      <br />
                      <br />
                      協力会社向けのマニュアルがございますので、目的に合わせてご参照ください。
                      <br />
                      ・作業員の技能者IDをBuildeeに登録して就業履歴を送信する場合のマニュアルは
                      <button
                        className='btn-text--sm no-padding'
                        onClick={() =>
                          this.downloadFileManual(
                            sendWorkDownload.fileCode,
                            sendWorkDownload.fileName
                          )
                        }
                      >
                        こちら
                      </button>
                      からダウンロードできます。
                      <br />
                      ・CCUSに登録されている労務安全情報を取得する場合のマニュアルは
                      <button
                        className='btn-text--sm no-padding'
                        onClick={() =>
                          this.downloadFileManual(
                            greenFileDownload.fileCode,
                            greenFileDownload.fileName
                          )
                        }
                      >
                        こちら
                      </button>
                      からダウンロードできます。
                    </div>

                    <div className='multi-table ccus-multi-table'>
                      <FormListSubHeader
                        title='CCUS基本情報'
                        info={
                          isShowBtnDeleteCCUS && (
                            <button
                              className='btn--negative'
                              onClick={this.handleDeleteCCUS}
                            >
                              {messageUtility.getMessage('I-000-018')}
                            </button>
                          )
                        }
                      />
                      <div className='multi-table__body'>
                        CCUSと連携するためには基本情報を必ず登録してください。
                      </div>
                      <div className='multi-table__body'>
                        <div className='multi-table__label multi-table__label--info'>
                          CCUS事業者ID
                        </div>
                        <div className='multi-table__table'>
                          <div
                            className={`multi-table__table ${_.isEmpty(
                              ccus_jigyousya_id
                            ) && 'text--error'}`}
                          >
                            {ccus_jigyousya_id || '未設定'}
                          </div>
                        </div>
                      </div>
                      <div className='multi-table__body'>
                        <div className='multi-table__label multi-table__label--info'>
                          CCUS管理者ID（登録責任者）
                        </div>
                        <div className='multi-table__table'>
                          <div
                            className={`multi-table__table ${_.isEmpty(
                              ccus_company_admin_id
                            ) && 'text--error'}`}
                          >
                            {ccus_company_admin_id || '未設定'}
                          </div>
                        </div>
                      </div>
                      <div className='wrap-ccus-company'>
                        <button
                          className='btn'
                          onClick={() =>
                            this.moveCcusCompanyForm(
                              ccus_jigyousya_id && ccus_company_admin_id
                                ? CCUS_PAGE.CcusCompanyEdit
                                : CCUS_PAGE.CcusCompanyCreate
                            )
                          }
                        >
                          {labelBtnCcusCompany}
                        </button>
                      </div>
                      {ccus_jigyousya_id && ccus_company_admin_id && (
                        <React.Fragment>
                          <CcusListUsers
                            isRolePartner={this.isRolePartner}
                            data={dataUserInfo}
                            editUser={() =>
                              this.moveCcusUserPage(
                                CCUS_PAGE.CcusCompanyUserEdit,
                                dataBasicInfo
                              )
                            }
                          />
                          <CcusListAddition
                            data={dataAdditionInfo}
                            editAdmin={this.moveCcusAdminForm}
                            createAdmin={() =>
                              this.moveCcusAdminForm(CCUS_PAGE.CcusAdminCreate)
                            }
                            editUser={this.moveCcusUserPage}
                          />
                        </React.Fragment>
                      )}
                    </div>
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DownloadFileErrorDialog
          visible={visibleDownloadErrorDialog}
          onClose={() => this.setVisibleDownloadErrorDialog(false)}
        />
        {this.renderCCUSDeleteConfirmation()}
        <CCUSNoDelegateNameDialog
          visible={visibleCcusNoDelegateNameDialog}
          onCancel={() =>
            this.setState({ visibleCcusNoDelegateNameDialog: false })
          }
          onConfirm={() => {
            _masterSlideLoader.show('CompanySaftyPreview', {
              state: {
                id: dataBasicInfo.company_id,
              },
            });
          }}
        />
      </div>
    );
  }
}

const greenFileDownload = {
  fileCode: 'ccusGetGreenfileInfoManual',
  fileName: '労務安全情報の取得手順.pdf',
};

const sendWorkDownload = {
  fileCode: 'ccusSendWorkHistoriesManual',
  fileName: '就業履歴CCUS送信設定手順.pdf',
};



// WEBPACK FOOTER //
// ./src/pages/PrimeCcusPreview.jsx